module.exports = __webpack_public_path__ + "img/pleisure_bodyimage03.642930c0.jpg";